
export const getSubleaseApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/sub-lease${queryString ? `?${queryString}` : ""}`;
};

export const deleteAttachment = (slug) => {
    return `lease/sub-lease/${slug}/attachments`
}

export const getSubleaseDetailApi = (params, slug) => {
    return `/lease/${params?.leaseSlug}/sub-lease`;
}
export const getSubleaseCardDetailApi = (params, slug) => {
    return `/lease/${params?.leaseSlug}/sub-lease/config`;
}

export const addSubleaseApi = (params, payload) => {
    return `/lease/${params?.leaseSlug}/sub-lease`;
}

export const editSubleaseApi = (params) => {
    return `/lease/${params?.leaseSlug}/sub-lease/${params?.slug}`;
}
export const editSubleaseCardApi = (params) => {
    return `/lease/${params?.leaseSlug}/sub-lease/config`;
}

export const subLeasefileUploadPostApi = (subLeaseSlug) => {
    return `/get-pre-signed-url/sublease/${subLeaseSlug}`;
};

export const deleteSubleaseApi = (params, payload) => {
    return `/lease/${params?.leaseSlug}/sub-lease`;
}

export const subLeasefileExportApi = (params) => {
    return `/lease/${params?.leaseSlug}/sub-lease/export/sub_lease`;
}

export const subleaseMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/party/${attachments_slug}`
}